"use client";

import React, { useState } from "react";
import { ChartBar, Calendar, CircleCheck, ChevronLeft, ChevronRight, Scissors, TrendingUp, Users } from "lucide-react";
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from "@/components/ui/chart";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const growthData = [{
  month: "Jan",
  clientes: 12
}, {
  month: "Fev",
  clientes: 19
}, {
  month: "Mar",
  clientes: 27
}, {
  month: "Abr",
  clientes: 35
}, {
  month: "Mai",
  clientes: 48
}, {
  month: "Jun",
  clientes: 63
}];
const chartConfig: ChartConfig = {
  clientes: {
    label: "Impacto",
    color: "var(--primary)"
  }
};
const services = [{
  label: "Reciclaje de Metales",
  enabled: true
}, {
  label: "Gestión de Residuos",
  enabled: true
}, {
  label: "Energía Renovable",
  enabled: false
}, {
  label: "Logística Inversa",
  enabled: true
}, {
  label: "Auditoría Ambiental",
  enabled: false
}];
const calendarDays = [{
  day: 1,
  hasEvent: false
}, {
  day: 2,
  hasEvent: false
}, {
  day: 3,
  hasEvent: true
}, {
  day: 4,
  hasEvent: false
}, {
  day: 5,
  hasEvent: true
}, {
  day: 6,
  hasEvent: false
}, {
  day: 7,
  hasEvent: false
}, {
  day: 8,
  hasEvent: true
}, {
  day: 9,
  hasEvent: false
}, {
  day: 10,
  hasEvent: true
}, {
  day: 11,
  hasEvent: true
}, {
  day: 12,
  hasEvent: false
}, {
  day: 13,
  hasEvent: false
}, {
  day: 14,
  hasEvent: false
}, {
  day: 15,
  hasEvent: true
}, {
  day: 16,
  hasEvent: false
}, {
  day: 17,
  hasEvent: true
}, {
  day: 18,
  hasEvent: false
}, {
  day: 19,
  hasEvent: false
}, {
  day: 20,
  hasEvent: true
}, {
  day: 21,
  hasEvent: false
}, {
  day: 22,
  hasEvent: false
}, {
  day: 23,
  hasEvent: true
}, {
  day: 24,
  hasEvent: false
}, {
  day: 25,
  hasEvent: true
}, {
  day: 26,
  hasEvent: false
}, {
  day: 27,
  hasEvent: false
}, {
  day: 28,
  hasEvent: false
}, {
  day: 29,
  hasEvent: true
}, {
  day: 30,
  hasEvent: false
}];
const weekDays = ["D", "L", "M", "M", "J", "V", "S"];
function ServiceToggle({
  label,
  enabled: initialEnabled
}: {
  label: string;
  enabled: boolean;
}) {
  const [enabled, setEnabled] = useState(initialEnabled);
  return <div className="flex items-center justify-between py-2 border-b border-border/30 last:border-0">
      <span className="text-sm font-default text-foreground/80">{label}</span>
      <button onClick={() => setEnabled(!enabled)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none ${enabled ? "bg-secondary" : "bg-muted"}`} aria-checked={enabled} role="switch">
        <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${enabled ? "translate-x-5" : "translate-x-1"}`} />
      </button>
    </div>;
}
export default function ReasDeImpacto() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}